<template>
  <v-dialog
    v-if="dataEndTime"
    :value="value"
    width="600"
    persistent
    @input="$emit('input', $event)">
    <v-card class="py-9">
      <div class="text-center">
        <v-icon
          size="150"
          color="primary">
          mdi-alarm-check
        </v-icon>
      </div>
      <div class="text-h4 font-weight-black text-center primary--text">
        ครบเวลาให้บริการแล้ว
      </div>
      <v-card-text class="pb-0">
        <div class="body-1 pa-2 text-center black--text">
          คุณ {{ dataEndTime?.patient?.firstName }} {{ dataEndTime?.patient?.lastName }}
        </div>
        <div
          v-if="dataEndTime?.items && dataEndTime.items.length"
          class="body-1 pa-2 text-center black--text">
          {{ dataEndTime.items[0].name }}
        </div>
        <div
          v-if="dataEndTime?.items && dataEndTime.items.length"
          class="body-1 pa-2 text-center black--text">
          เตียง {{ dataEndTime.items[0].bed }}
        </div>
      </v-card-text>
      <v-card-actions class="pa-4">
        <div class="d-flex justify-center w-full">
          <v-btn
            width="100"
            class="consent__button-submit white--text text-capitalize"
            rounded
            depressed
            @click="goQueuePage()">
            ไปที่หน้าคิว
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalConsent',
  props: {
    dataEndTime: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goQueuePage () {
      const routeName = this.$route.name
      if (routeName === 'QueuePage') {
        this.$router.go(0)
      } else {
        this.$router.replace({ name: 'QueuePage' })
      }
      this.$emit('close', false)
    },
    close () {
      this.$emit('input', false)
    }

  }
}
</script>

<style lang="scss" scoped>
  .consent__button-submit {
    background: linear-gradient(90deg, var(--v-menu-base) 0%, var(--v-primary-base) 100%);
  }
</style>
